module.exports = __webpack_public_path__ + "297fc06bb01e13a3d182198a73598271.MP3";